import * as React from 'react';

import { cn } from '../../../../lib';

export interface TouchSelectOptionProps {
  label: React.ReactNode;
  subLabel?: React.ReactNode;
  rightInfo?: React.ReactNode;
  isDisabled?: boolean;
  isSelected: boolean;
  isFocused: boolean;
  isKeyboardNavigating: boolean;
  onSelect: VoidFunction;
  onHover: VoidFunction;
}

export const TouchSelectOption: React.FC<TouchSelectOptionProps> = ({
  label,
  subLabel,
  rightInfo,
  isDisabled,
  isSelected,
  isFocused,
  isKeyboardNavigating,
  onSelect,
  onHover,
}) => (
  <div
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!isDisabled) {
        onSelect();
      }
    }}
    onMouseEnter={() => {
      if (!isKeyboardNavigating) {
        onHover();
      }
    }}
    className={cn(
      '@TouchSelectOption',
      isDisabled && 'cursor-not-allowed',
      !isDisabled && 'cursor-pointer',
    )}
  >
    <div
      className={cn(
        'mt-[1px] flex min-h-12 items-center justify-between gap-2 rounded px-3 py-2 text-sm text-neutral',
        isSelected && 'bg-primary/10',
        isFocused && !isDisabled && 'bg-primary',
        isDisabled && 'text-neutral/60 opacity-50',
      )}
      data-type-id="re-ui-select-option"
    >
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <div
          className={cn(
            'truncate',
            isSelected && 'font-medium',
            !isSelected && 'font-normal',
          )}
        >
          {label}
        </div>
        {subLabel && (
          <div className="truncate text-xs opacity-70">{subLabel}</div>
        )}
      </div>
      {rightInfo && (
        <div
          className={cn(
            'shrink-0 text-right',
            isSelected && 'font-medium',
            !isSelected && 'font-normal',
          )}
        >
          {rightInfo}
        </div>
      )}
    </div>
  </div>
);
